import { render } from "./Dashboard_Section_Card.vue?vue&type=template&id=a2dc4d8e"
import script from "./Dashboard_Section_Card.vue?vue&type=script&lang=js"
export * from "./Dashboard_Section_Card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__